// GENERATED by scripts/generate-format-schema.mjs: DO NOT EDIT.
// Source: @walkeros/core partialEventJsonSchema (canonical zod EventSchema).
// `format: true` validates that the value is a valid WalkerOS.PartialEvent:
// the canonical event structure with all fields optional, so it checks shape
// and field types, not presence. Required-field enforcement is the contract
// arm's job (events/schema with required).
// Regenerate: npm run generate:format-schema

export const eventFormatSchema = Object.freeze({
  $schema: 'http://json-schema.org/draft-07/schema#',
  description: 'Partial event structure with all fields optional',
  allOf: [
    {
      $ref: '#/definitions/WalkerOSPartialEvent',
    },
  ],
  definitions: {
    WalkerOSProperty: {
      title: 'WalkerOS.Property',
      description:
        'PropertyType or an array of PropertyType. Recursive structure for nested objects and arrays.',
      anyOf: [
        {
          $ref: '#/definitions/WalkerOSPropertyType',
        },
        {
          type: 'array',
          items: {
            $ref: '#/definitions/WalkerOSPropertyType',
          },
        },
      ],
    },
    WalkerOSPropertyType: {
      title: 'WalkerOS.PropertyType',
      description:
        'Base property value types (boolean, string, number, or nested Property record).',
      anyOf: [
        {
          type: 'boolean',
        },
        {
          type: 'string',
        },
        {
          type: 'number',
        },
        {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            $ref: '#/definitions/WalkerOSProperty',
          },
        },
      ],
    },
    WalkerOSProperties: {
      type: 'object',
      propertyNames: {
        type: 'string',
      },
      additionalProperties: {
        allOf: [
          {
            $ref: '#/definitions/WalkerOSProperty',
          },
        ],
      },
      title: 'WalkerOS.Properties',
      description: 'Flexible property collection with optional values.',
    },
    WalkerOSOrderedProperties: {
      type: 'object',
      propertyNames: {
        type: 'string',
      },
      additionalProperties: {
        type: 'array',
        items: [
          {
            $ref: '#/definitions/WalkerOSProperty',
          },
          {
            type: 'number',
          },
        ],
      },
      title: 'WalkerOS.OrderedProperties',
      description:
        'Ordered properties with [value, order] tuples for priority control.',
    },
    WalkerOSUser: {
      allOf: [
        {
          description: 'Flexible property collection with optional values',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSProperties',
            },
          ],
        },
        {
          type: 'object',
          properties: {
            id: {
              description: 'User identifier',
              type: 'string',
            },
            device: {
              description: 'Device identifier',
              type: 'string',
            },
            session: {
              description: 'Session identifier',
              type: 'string',
            },
            hash: {
              description: 'Hashed identifier',
              type: 'string',
            },
            address: {
              description: 'User address',
              type: 'string',
            },
            email: {
              description: 'User email address',
              type: 'string',
              format: 'email',
              pattern:
                "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$",
            },
            phone: {
              description: 'User phone number',
              type: 'string',
            },
            userAgent: {
              description: 'Browser user agent string',
              type: 'string',
            },
            browser: {
              description: 'Browser name',
              type: 'string',
            },
            browserVersion: {
              description: 'Browser version',
              type: 'string',
            },
            deviceType: {
              description: 'Device type (mobile, desktop, tablet)',
              type: 'string',
            },
            os: {
              description: 'Operating system',
              type: 'string',
            },
            osVersion: {
              description: 'Operating system version',
              type: 'string',
            },
            screenSize: {
              description: 'Screen dimensions',
              type: 'string',
            },
            language: {
              description: 'User language',
              type: 'string',
            },
            country: {
              description: 'User country',
              type: 'string',
            },
            region: {
              description: 'User region/state',
              type: 'string',
            },
            city: {
              description: 'User city',
              type: 'string',
            },
            zip: {
              description: 'User postal code',
              type: 'string',
            },
            timezone: {
              description: 'User timezone',
              type: 'string',
            },
            ip: {
              description: 'User IP address',
              type: 'string',
            },
            internal: {
              description: 'Internal user flag (employee, test user)',
              type: 'boolean',
            },
          },
          additionalProperties: false,
        },
      ],
      title: 'WalkerOS.User',
      description: 'User identification and attributes.',
    },
    __schema0: {
      description: 'Nested entity structure with recursive nesting support',
      $ref: '#/definitions/WalkerOSEntity',
    },
    WalkerOSEntity: {
      title: 'WalkerOS.Entity',
      description: 'Nested entity structure with recursive nesting support.',
      type: 'object',
      properties: {
        entity: {
          type: 'string',
          description: 'Entity name',
        },
        data: {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            allOf: [
              {
                $ref: '#/definitions/WalkerOSProperty',
              },
            ],
          },
          title: 'WalkerOS.Properties',
          description: 'Entity-specific properties',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSProperties',
            },
          ],
        },
        nested: {
          description: 'Nested child entities',
          type: 'array',
          items: {
            $ref: '#/definitions/__schema0',
          },
        },
        context: {
          description: 'Entity context data',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSOrderedProperties',
            },
          ],
        },
      },
      required: ['entity', 'data'],
      additionalProperties: false,
    },
    WalkerOSEntities: {
      type: 'array',
      items: {
        $ref: '#/definitions/__schema0',
      },
      title: 'WalkerOS.Entities',
      description: 'Array of nested entities.',
    },
    WalkerOSConsent: {
      type: 'object',
      propertyNames: {
        type: 'string',
      },
      additionalProperties: {
        type: 'boolean',
      },
      title: 'WalkerOS.Consent',
      description:
        'Consent state mapping. Keys are consent groups (e.g. marketing, functional), values are booleans for granted/denied.',
    },
    WalkerOSSource: {
      allOf: [
        {
          description: 'Flexible property collection with optional values',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSProperties',
            },
          ],
        },
        {
          type: 'object',
          properties: {
            type: {
              type: 'string',
              description: 'Source kind (browser, dataLayer, gtag, ...)',
            },
            platform: {
              description:
                'Runtime platform (web, server, app, ios, android, terminal, ...)',
              type: 'string',
            },
            version: {
              description: 'Deployment version of the source emitter',
              type: 'string',
            },
            schema: {
              description:
                'Event model spec version (collector defaults to "4")',
              type: 'string',
            },
            count: {
              description: 'Emission sequence per run',
              type: 'integer',
              minimum: 0,
              maximum: 9007199254740991,
            },
            trace: {
              description:
                'Trace id shared by every event of a run (W3C trace-id shape)',
              type: 'string',
            },
            release: {
              description:
                'Per-flow config release map, keyed by flow name; accumulates across walkerOS crossings',
              type: 'object',
              propertyNames: {
                type: 'string',
              },
              additionalProperties: {
                type: 'string',
              },
            },
            url: {
              type: 'string',
            },
            referrer: {
              type: 'string',
            },
            tool: {
              type: 'string',
            },
            command: {
              type: 'string',
            },
          },
          required: ['type'],
          additionalProperties: false,
        },
      ],
      title: 'WalkerOS.Source',
      description: 'Event source information (origin of the event).',
    },
    WalkerOSPartialEvent: {
      type: 'object',
      properties: {
        name: {
          type: 'string',
          description:
            'Event name in "entity action" format (e.g., "page view", "product add")',
        },
        data: {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            allOf: [
              {
                $ref: '#/definitions/WalkerOSProperty',
              },
            ],
          },
          title: 'WalkerOS.Properties',
          description: 'Event-specific properties',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSProperties',
            },
          ],
        },
        context: {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            type: 'array',
            items: [
              {
                $ref: '#/definitions/WalkerOSProperty',
              },
              {
                type: 'number',
              },
            ],
          },
          title: 'WalkerOS.OrderedProperties',
          description: 'Ordered context properties with priorities',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSOrderedProperties',
            },
          ],
        },
        globals: {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            allOf: [
              {
                $ref: '#/definitions/WalkerOSProperty',
              },
            ],
          },
          title: 'WalkerOS.Properties',
          description: 'Global properties shared across events',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSProperties',
            },
          ],
        },
        custom: {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            allOf: [
              {
                $ref: '#/definitions/WalkerOSProperty',
              },
            ],
          },
          title: 'WalkerOS.Properties',
          description: 'Custom implementation-specific properties',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSProperties',
            },
          ],
        },
        user: {
          allOf: [
            {
              description: 'Flexible property collection with optional values',
              allOf: [
                {
                  $ref: '#/definitions/WalkerOSProperties',
                },
              ],
            },
            {
              type: 'object',
              properties: {
                id: {
                  description: 'User identifier',
                  type: 'string',
                },
                device: {
                  description: 'Device identifier',
                  type: 'string',
                },
                session: {
                  description: 'Session identifier',
                  type: 'string',
                },
                hash: {
                  description: 'Hashed identifier',
                  type: 'string',
                },
                address: {
                  description: 'User address',
                  type: 'string',
                },
                email: {
                  description: 'User email address',
                  type: 'string',
                  format: 'email',
                  pattern:
                    "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$",
                },
                phone: {
                  description: 'User phone number',
                  type: 'string',
                },
                userAgent: {
                  description: 'Browser user agent string',
                  type: 'string',
                },
                browser: {
                  description: 'Browser name',
                  type: 'string',
                },
                browserVersion: {
                  description: 'Browser version',
                  type: 'string',
                },
                deviceType: {
                  description: 'Device type (mobile, desktop, tablet)',
                  type: 'string',
                },
                os: {
                  description: 'Operating system',
                  type: 'string',
                },
                osVersion: {
                  description: 'Operating system version',
                  type: 'string',
                },
                screenSize: {
                  description: 'Screen dimensions',
                  type: 'string',
                },
                language: {
                  description: 'User language',
                  type: 'string',
                },
                country: {
                  description: 'User country',
                  type: 'string',
                },
                region: {
                  description: 'User region/state',
                  type: 'string',
                },
                city: {
                  description: 'User city',
                  type: 'string',
                },
                zip: {
                  description: 'User postal code',
                  type: 'string',
                },
                timezone: {
                  description: 'User timezone',
                  type: 'string',
                },
                ip: {
                  description: 'User IP address',
                  type: 'string',
                },
                internal: {
                  description: 'Internal user flag (employee, test user)',
                  type: 'boolean',
                },
              },
              additionalProperties: false,
            },
          ],
          title: 'WalkerOS.User',
          description: 'User identification and attributes',
        },
        nested: {
          type: 'array',
          items: {
            $ref: '#/definitions/__schema0',
          },
          title: 'WalkerOS.Entities',
          description: 'Related nested entities',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSEntities',
            },
          ],
        },
        consent: {
          type: 'object',
          propertyNames: {
            type: 'string',
          },
          additionalProperties: {
            type: 'boolean',
          },
          title: 'WalkerOS.Consent',
          description: 'Consent states at event time',
          allOf: [
            {
              $ref: '#/definitions/WalkerOSConsent',
            },
          ],
        },
        id: {
          type: 'string',
          minLength: 1,
          description: 'W3C span_id, 16 lowercase hex characters',
        },
        trigger: {
          type: 'string',
          description: 'Event trigger identifier',
        },
        entity: {
          type: 'string',
          description: 'Parsed entity from event name',
        },
        action: {
          type: 'string',
          description: 'Parsed action from event name',
        },
        timestamp: {
          type: 'integer',
          exclusiveMinimum: 0,
          maximum: 9007199254740991,
          description: 'Unix timestamp in milliseconds since epoch',
        },
        timing: {
          type: 'number',
          description: 'Event processing timing information',
        },
        source: {
          allOf: [
            {
              description: 'Flexible property collection with optional values',
              allOf: [
                {
                  $ref: '#/definitions/WalkerOSProperties',
                },
              ],
            },
            {
              type: 'object',
              properties: {
                type: {
                  type: 'string',
                  description: 'Source kind (browser, dataLayer, gtag, ...)',
                },
                platform: {
                  description:
                    'Runtime platform (web, server, app, ios, android, terminal, ...)',
                  type: 'string',
                },
                version: {
                  description: 'Deployment version of the source emitter',
                  type: 'string',
                },
                schema: {
                  description:
                    'Event model spec version (collector defaults to "4")',
                  type: 'string',
                },
                count: {
                  description: 'Emission sequence per run',
                  type: 'integer',
                  minimum: 0,
                  maximum: 9007199254740991,
                },
                trace: {
                  description:
                    'Trace id shared by every event of a run (W3C trace-id shape)',
                  type: 'string',
                },
                release: {
                  description:
                    'Per-flow config release map, keyed by flow name; accumulates across walkerOS crossings',
                  type: 'object',
                  propertyNames: {
                    type: 'string',
                  },
                  additionalProperties: {
                    type: 'string',
                  },
                },
                url: {
                  type: 'string',
                },
                referrer: {
                  type: 'string',
                },
                tool: {
                  type: 'string',
                },
                command: {
                  type: 'string',
                },
              },
              required: ['type'],
              additionalProperties: false,
            },
          ],
          title: 'WalkerOS.Source',
          description: 'Event source information',
        },
      },
      additionalProperties: false,
      title: 'WalkerOS.PartialEvent',
      description: 'Partial event structure with all fields optional.',
    },
  },
} as const);
